import React from "react";
import styled from "styled-components";

const AlertContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  pointer-events: none;
`;

const getVariantStyles = (variant) => {
  switch (variant) {
    case 'info':
      return { backgroundColor: '#d1ecf1', color: '#0c5460' };
    case 'success':
      return { backgroundColor: '#d4edda', color: '#155724' };
    case 'warning':
      return { backgroundColor: '#fff3cd', color: '#856404' };
    case 'danger':
      return { backgroundColor: '#f8d7da', color: '#721c24' };
    default:
      return { backgroundColor: '#9c27b0', color: 'white' };
  }
};

const AlertWrapper = styled.div`
  background-color: ${props => getVariantStyles(props.variant).backgroundColor};
  color: ${props => getVariantStyles(props.variant).color};
  padding: 6px 20px;
  margin-top: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  pointer-events: auto;
  animation: fadeInDown 0.3s ease-out;
  
  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const P = styled.p`
  font-weight: 500;
  font-size: 14px;
  margin: 0;
  text-align: center;
`;

const Alert = ({ variant = "primary", children }) => {
  return (
    <AlertContainer>
      <AlertWrapper variant={variant}>
        <P>{children}</P>
      </AlertWrapper>
    </AlertContainer>
  );
};

export default React.memo(Alert);
